var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"materials"},_vm._l((_vm.materials),function(material){return _c('v-category-button',{key:material.id,attrs:{"type":material.type,"active":_vm.selectedLogoFlg == material.id,"disabled":material.disabled},on:{"click":function($event){return _vm.setLogoFlg(material.id)}}},[_vm._v(" "+_vm._s(material.text)+" ")])}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }